import { SegmentedFormControl } from '@savvy-kit/components/segmented-form-control';

import type { ClientPortalTimeRange } from './constants';
import { CLIENT_PORTAL_TIME_RANGES, isClientPortalTimeRange } from './constants';

type TimeRangeToggleProps = {
  readonly value: ClientPortalTimeRange;
  readonly onChange: (value: ClientPortalTimeRange) => void;
  readonly label: string;
  readonly ranges?: readonly ClientPortalTimeRange[];
  readonly className?: string;
};

export function TimeRangeToggle({ value, onChange, label, ranges, className }: TimeRangeToggleProps) {
  const options = CLIENT_PORTAL_TIME_RANGES.filter((range) => ranges?.includes(range.value) ?? true);
  if (options.length < 2) {
    return null;
  }

  return (
    <SegmentedFormControl
      label={label}
      hideLabel
      options={options.map((range) => ({ value: range.value, label: range.label }))}
      value={value}
      onValueChange={(next) => {
        if (isClientPortalTimeRange(next) && next !== value) {
          onChange(next);
        }
      }}
      className={className}
    />
  );
}
